export const environment = {
  Certification: {
    id: '1',
    name: 'Certification',
    shortName: 'CERT',
  },
  Production: {
    id: '2',
    name: 'Production',
    shortName: 'PROD',
  },
};
